import { BaseEntity } from "@app/models/rest/base-entity";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("systemSearchMetas")
export class SystemSearchMeta extends BaseEntity {
  entityName: string;
  jsonData: string;
}
